const REGEX_HEX_COLOR_S = /^#?([0-9A-Fa-f]{1})([0-9A-Fa-f]{1})([0-9A-Fa-f]{1})$/;
const REGEX_HEX_COLOR_L = /^#?([0-9A-Fa-f]{2})([0-9A-Fa-f]{2})([0-9A-Fa-f]{2})$/;

const CONTRAST_RATIO_THRESHOLD = 2.6;

export function isGoodContrastRatio(c1, c2) {
  return getContrastRatio(c1, c2) > CONTRAST_RATIO_THRESHOLD;
}

// コントラスト比を返す
function getContrastRatio(color1, color2) {
  const l1 = getRelativeLuminance(color1);
  const l2 = getRelativeLuminance(color2);
  const [bright, dark] = l1 > l2 ? [l1, l2] : [l2, l1];
  return (bright + 0.05) / (dark + 0.05);
}

// 相対輝度を返す
function getRelativeLuminance(color) {
  const [r, g, b] = parseHexCode(color).map(calculateLinearRGB);
  return 0.2126 * r + 0.7152 * g + 0.0722 * b;
}

// 相対輝度計算に使うためのRGBを返す
function calculateLinearRGB(rgb) {
  const srgb = rgb / 255;
  if (srgb <= 0.03928) {
    return srgb / 12.92;
  } else {
    return Math.pow((srgb + 0.055) / 1.055, 2.4);
  }
}

// hexをrgbに変換
function parseHexCode(color = '') {
  const match2 = color.match(REGEX_HEX_COLOR_L);
  if (match2) {
    const r = parseInt(match2[1], 16);
    const g = parseInt(match2[2], 16);
    const b = parseInt(match2[3], 16);
    return [r, g, b];
  }
  const match1 = color.match(REGEX_HEX_COLOR_S);
  if (match1) {
    const r = parseInt(match1[1] + match1[1], 16);
    const g = parseInt(match1[2] + match1[2], 16);
    const b = parseInt(match1[3] + match1[3], 16);
    return [r, g, b];
  }
  throw new Error('invalid color code: ' + color);
}
